<p-dialog
  [header]="voidMode() ? 'Confirmar cancelación del cargo de validación' : 'Resolver transacción en revisión'"
  [visible]="visible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving()"
  appendTo="body"
  [style]="{ width: 'min(30rem, calc(100vw - 2rem))' }">
  <form [formGroup]="form" class="flex flex-col gap-4 pt-1">
    @if (voidMode()) {
      <p class="text-sm text-slate-600 m-0">
        Confirma que el cargo de validación ya se canceló o devolvió en el portal de Paycode. Se detienen los reintentos automáticos.
      </p>
    } @else if (verification()) {
      <p class="text-sm text-slate-600 m-0">
        Confirma con Paycode el resultado real del cargo de validación. Si fue aprobado, Pento lo cancelará; no se registra venta.
      </p>
    } @else {
      <p class="text-sm text-slate-600 m-0">
        Confirma con el proveedor (Paycode) el resultado real del cargo. Si fue aprobado se registra la venta y el pago.
      </p>
    }
    <p-selectbutton formControlName="outcome" [options]="outcomeOptions()" optionLabel="label" optionValue="value" />
    @if (!voidMode()) {
      <p-floatlabel class="w-full" variant="on">
        <input pInputText id="mitResolveRef" formControlName="providerReference" maxlength="100" class="w-full" />
        <label for="mitResolveRef">Referencia del proveedor{{ form.controls.outcome.value === 'APPROVED' ? ' *' : '' }}</label>
      </p-floatlabel>
      @if (verification() && form.controls.outcome.value === 'APPROVED') {
        <p-floatlabel class="w-full" variant="on">
          <input pInputText id="mitResolveTrack" formControlName="providerTrackCode" maxlength="100" class="w-full" />
          <label for="mitResolveTrack">Track code *</label>
        </p-floatlabel>
      }
    }
    <p-floatlabel class="w-full" variant="on">
      <textarea pTextarea id="mitResolveNote" formControlName="note" rows="3" maxlength="500" class="w-full"></textarea>
      <label for="mitResolveNote">Nota{{ voidMode() ? ' *' : '' }}</label>
    </p-floatlabel>
    @if (error()) {
      <p class="text-sm text-red-600 m-0">{{ error() }}</p>
    }
  </form>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cerrar" severity="secondary" [text]="true" type="button" [disabled]="saving()" (onClick)="close()" />
      <p-button [label]="voidMode() ? 'Confirmar' : 'Resolver'" icon="pi pi-check" type="button" [loading]="saving()"
        [disabled]="!form.controls.outcome.value" (onClick)="save()" />
    </div>
  </ng-template>
</p-dialog>
